import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    Typography,
    Select,
    MenuItem,
    InputLabel,
    Box,
    Tooltip,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Checkbox,
    FormControlLabel,
    FormControl,
    Grid,
    DialogActions,
    Divider,
    Switch,
} from '@material-ui/core';
import Draggable from 'react-draggable';
import SettingsIcon from '@material-ui/icons/Settings';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import CenterFocusWeakIcon from '@mui/icons-material/CenterFocusWeak';
import { SwapHoriz } from '@material-ui/icons';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import CircleIcon from '@mui/icons-material/Circle';
import SelectAllIcon from '@material-ui/icons/SelectAll';

export default function ColumnEditor(props) {
    const state = useSelector(state => state);
    const [columnInfoOpen, setColumnInfoOpen] = React.useState(false);
    const [mastSettingsOpen, setMastSettingsOpen] = React.useState(false);
    const [currColumn, setCurrColumn] = React.useState([]);
    const [luminNameList, setLuminNameList] = React.useState([]);
    const [luminIdList, setLuminIdList] = React.useState([]);
    const [luminColorList, setLuminColorList] = React.useState([]);
    const [displayX, setDisplayX] = React.useState(0);
    const [displayY, setDisplayY] = React.useState(0);
    const [columnColors, setColumnColors] = React.useState({});
    const [groupDialogOpen, setGroupDialogOpen] = React.useState(false);
    const [selectedColumns, setSelectedColumns] = React.useState([]);
    const [newGroupName, setNewGroupName] = React.useState("");
    const [groupSettingsOpen, setGroupSettingsOpen] = React.useState(false);
    const [groupName, setGroupName] = React.useState("");
    const [setLanternsDialogOpen, toggleSetLanternsDialog] = React.useState(false);


    const handleInfoOpen = (index) => {
        const column = props.columns[index];
        const xScaler = props.realWorldWidth / props.imagePixelWidth;
        const yScaler = props.realWorldHeight / props.imagePixelHeight;

        setDisplayX((column.values.point.x * xScaler).toFixed(2));
        setDisplayY((column.values.point.y * yScaler).toFixed(2));
        setCurrColumn(column);

        if (column.isMast) {
            setMastSettingsOpen(true);
        } else {
            setColumnInfoOpen(true);
        }
    };

    const handleLanternOutreach = (e) => {
        setCurrColumn((prevColumn) => ({
            ...prevColumn,
            values: {
                ...prevColumn.values,
                useLanternOutreach: e.target.checked,
            }
        }));
    };

    useEffect(() => {
        if (
            currColumn?.values?.lanterns &&
            currColumn?.values?.configuration !== "None"
        ) {
            const newTilt = currColumn.values.tilt || 0;
            const mountingType = currColumn.values.mountingType;
            const positionAngle = currColumn.values.positionAngle;
            const lanterns = currColumn.values.lanterns;
            const count = lanterns.length;

            const updatedLanterns = lanterns.map((lantern, index) => {
                let positionAngleUpdate =
                    mountingType === "wall"
                        ? positionAngle
                        : (360 / count) * index;

                let beamEndPoint = lantern.beamAimingInfo?.beamEndPoint;

                if (mountingType === "wall") {
                    beamEndPoint = undefined;
                }

                return {
                    ...lantern,
                    positionAngle: positionAngleUpdate,
                    beamAimingInfo: {
                        ...lantern.beamAimingInfo,
                        tilt: newTilt,
                        beamEndPoint,
                    },
                };
            });

            setCurrColumn((prevColumn) => ({
                ...prevColumn,
                values: {
                    ...prevColumn.values,
                    lanterns: updatedLanterns,
                },
            }));
        }
    }, [
        currColumn?.values?.mountingType,
        currColumn?.values?.configuration,
        currColumn?.values?.positionAngle,
        currColumn?.values?.tilt,
    ]);







    const handleChangeCurrColumn = (e) => {
        const { name, value } = e.target;

        if (name === 'name') {
            setCurrColumn((prevColumn) => ({
                ...prevColumn,
                name: value
            }));
        } else if (name === 'x' || name === 'y') {
            if (name === 'x') setDisplayX(value);
            if (name === 'y') setDisplayY(value);
        } else if (name === 'angle') {
            setCurrColumn((prevColumn) => ({
                ...prevColumn,
                values: {
                    ...prevColumn.values,
                    positionAngle: value,
                }
            }));
        }
        else if (name === 'luminaireId') {
            const newColumn = {
                ...currColumn,
                values: {
                    ...currColumn.values,
                    luminaireId: value
                }
            };

            const luminaireIndex = luminIdList.indexOf(value);
            const newColor = luminaireIndex >= 0 ? luminColorList[luminaireIndex] : '#212529';

            setCurrColumn(newColumn);
            setColumnColors(prevColors => ({
                ...prevColors,
                [currColumn.id]: newColor
            }));
        } else if (name === 'mounting') {
            setCurrColumn((prevColumn) => {
                const updatedLanterns = prevColumn.values.lanterns.map(lantern => ({
                    ...lantern,
                    offset: parseFloat(lantern.offset || 0)
                }));

                return {
                    ...prevColumn,
                    values: {
                        ...prevColumn.values,
                        mountingType: value,
                        lanterns: updatedLanterns,
                    }
                };
            });
        } else {
            setCurrColumn((prevColumn) => ({
                ...prevColumn,
                values: {
                    ...prevColumn.values,
                    [name]: value
                }
            }));
        }
    };


    const swapColumnAndMast = (name, isMast) => {
        console.log(props)

        if (name.includes("Column") && isMast !== true) {
            return name.replace("Column", "Mast");
        } else if (name.includes("Mast") && isMast === true) {
            return name.replace("Mast", "Column");
        }
        return name;
    };

    const getTiltFromBeamLength = (beamLength, height = 6) => {
        const radians = Math.atan(beamLength / height);
        const degrees = radians * (180 / Math.PI);
        return +(degrees).toFixed(2);
    };


    const swapType = (id) => {
        const updatedColumns = props.columns.map(column =>
            column.id === id
                ? {
                    ...column,
                    isMast: !column.isMast,
                    values: {
                        ...column.values,
                        mountingType: column.values.mountingType || "column",
                        useLanternOutreach: column.values.useLanternOutreach || false,
                        lanterns: column.isMast ? column.values.lanterns : column.values.lanterns || [
                            {
                                positionAngle: 0,
                                offset: 0,
                                outreach: column.values.outreach,
                                luminaireId: column.values.luminaireId,
                                color: columnColors[column.id],
                                beamAimingInfo: {
                                    beamLength: column.values.beamLength || 0.75,
                                    beamEndPoint: {
                                        x: column.values.point.x + (column.values.beamLength || 0.75) * Math.cos((0 - 90) * Math.PI / 180),
                                        y: column.values.point.y + (column.values.beamLength || 0.75) * Math.sin((0 - 90) * Math.PI / 180),
                                    },
                                    beamOrigin: {
                                        x: column.values.point.x,
                                        y: column.values.point.y,
                                    },
                                    tilt: getTiltFromBeamLength(column.values.beamLength, column.values.height) || column.values.tilt || 0,
                                }
                            }
                        ]
                    },
                    name: swapColumnAndMast(column.name, column.isMast),
                }
                : column
        );
        props.setColumns(updatedColumns);
    };




    const handleSave = () => {
        const xScaler = props.realWorldWidth / props.imagePixelWidth;
        const yScaler = props.realWorldHeight / props.imagePixelHeight;

        const rawAngle = parseFloat(currColumn.values.positionAngle ?? 0);
        const normalizedAngle = ((rawAngle % 360) + 360) % 360;

        const updatedItem = {
            ...currColumn,
            values: {
                ...currColumn.values,
                positionAngle: normalizedAngle,
                point: {
                    x: displayX / xScaler,
                    y: displayY / yScaler
                }
            }
        };

        const updatedColumns = props.columnList.map(col =>
            col.id === currColumn.id ? updatedItem : col
        );

        props.setColumns(updatedColumns);
        setColumnInfoOpen(false);
    };


    const handleAddLantern = (count) => {
        const lanterns = currColumn?.values?.lanterns || [];

        const baseAngles = Array.from({ length: 8 }, (_, i) => i * 22.5);
        const preferredAngles = [];

        for (let i = 0; i < baseAngles.length; i++) {
            const angle = baseAngles[i];
            preferredAngles.push(angle);
            preferredAngles.push((angle + 180) % 360);
        }

        const generateLantern = (lanternsSoFar, overrideAngle = null) => {
            const mountingType = currColumn?.values?.mountingType;
            const existingAngles = lanternsSoFar.map(l => Number(l.positionAngle));
            let defaultAngle;

            if (mountingType === "wall") {
                defaultAngle = Number(currColumn?.values?.positionAngle ?? 0);
            } else {
                if (overrideAngle !== null && !isNaN(overrideAngle)) {
                    defaultAngle = Number(overrideAngle);
                } else {
                    const foundAngle = preferredAngles.find(a => !existingAngles.includes(a));
                    defaultAngle = typeof foundAngle === 'number'
                        ? foundAngle
                        : (lanternsSoFar.length * 23) % 360;
                }
            }

            const existingOffsets = lanternsSoFar.map(l => Number(l.offset));
            let offset = 0;
            if (existingOffsets.includes(0)) {
                let absOffset = 1;
                while (existingOffsets.includes(-absOffset) && existingOffsets.includes(absOffset)) {
                    absOffset++;
                }
                offset = !existingOffsets.includes(-absOffset) ? -absOffset : absOffset;
            }

            const defaultLuminaireId = luminIdList[0];
            const color = luminColorList[luminIdList.indexOf(defaultLuminaireId)];
            const beamLength = parseFloat(currColumn?.values?.beamLength ?? 0.75);

            console.log("new column", currColumn);

            const displayX = Number(currColumn?.values?.point?.x || 0);
            const displayY = Number(currColumn?.values?.point?.y || 0);

            const columnAngleDeg = Number(currColumn?.values?.positionAngle ?? 0);
            const columnAngleRad = (columnAngleDeg * Math.PI) / 180;

            const armX = Number(offset);
            const armY = -0.2;

            const preRotatedBase = {
                x: displayX + armX,
                y: displayY + armY,
            };

            const rotateAround = (point, center, angleRad) => {
                const translated = {
                    x: point.x - center.x,
                    y: point.y - center.y,
                };
                const rotated = {
                    x: translated.x * Math.cos(angleRad) - translated.y * Math.sin(angleRad),
                    y: translated.x * Math.sin(angleRad) + translated.y * Math.cos(angleRad),
                };
                return {
                    x: center.x + rotated.x,
                    y: center.y + rotated.y,
                };
            };

            const beamOrigin = rotateAround(preRotatedBase, { x: displayX, y: displayY }, columnAngleRad);

            return {
                positionAngle: Number(defaultAngle),
                offset: Number(offset),
                luminaireId: defaultLuminaireId,
                color,
                outreach: Number(currColumn?.values?.outreach || 0),
                beamAimingInfo: {
                    beamLength: Number(beamLength),
                    beamOrigin,
                    tilt: Number(getTiltFromBeamLength(beamLength, currColumn.values?.height)),
                }
            };
        };

        let newLanterns = [...lanterns];

        if (typeof count === 'number') {
            newLanterns = [];
            for (let i = 0; i < Math.min(count, 16); i++) {
                const evenlySpacedAngle = (360 / count) * i;
                newLanterns.push(generateLantern(newLanterns, evenlySpacedAngle));
            }
        } else {
            if (newLanterns.length < 16) {
                newLanterns.push(generateLantern(newLanterns));
            }
        }

        handleChangeCurrColumn({
            target: {
                name: 'lanterns',
                value: newLanterns
            }
        });
    };












    const handleRemoveLantern = (index) => {
        const updatedLanterns = [...currColumn?.values?.lanterns];
        updatedLanterns.splice(index, 1);

        handleChangeCurrColumn({
            target: {
                name: 'lanterns',
                value: updatedLanterns
            }
        });
    };




    const handleLanternAngleChange = (index, angle) => {
        const updatedLanterns = [...currColumn?.values?.lanterns];
        updatedLanterns[index].positionAngle = angle;
        handleChangeCurrColumn({ target: { name: 'lanterns', value: updatedLanterns } });
    };

    const handleLanternOffsetChange = (index, offset) => {
        const updatedLanterns = [...currColumn?.values?.lanterns];
        updatedLanterns[index].offset = offset;
        handleChangeCurrColumn({ target: { name: 'lanterns', value: updatedLanterns } });
    };

    const handleLanternLuminaireChange = (index, luminaireId) => {
        const lanterns = [...(currColumn?.values?.lanterns || [])];
        const color = luminColorList[luminIdList.indexOf(luminaireId)];

        lanterns[index] = {
            ...lanterns[index],
            luminaireId,
            color
        };

        handleChangeCurrColumn({ target: { name: "lanterns", value: lanterns } });
    };

    const handleLanternOutreachChange = (index, outreach) => {
        const lanterns = [...(currColumn?.values?.lanterns || [])];

        lanterns[index] = {
            ...lanterns[index],
            outreach: outreach
        };

        handleChangeCurrColumn({ target: { name: "lanterns", value: lanterns } });
    }

    const handleLanternTiltChange = (index, tilt) => {
        const lanterns = [...(currColumn?.values?.lanterns || [])];

        lanterns[index] = {
            ...lanterns[index],
            beamAimingInfo: {
                ...lanterns[index].beamAimingInfo,
                tilt: tilt
            }
        };

        handleChangeCurrColumn({ target: { name: "lanterns", value: lanterns } });
    }

    const getBeamLengthFromTilt = (tilt, height = 6) => {
        const radians = (90 - tilt) * (Math.PI / 180);
        const beamLength = height / Math.tan(radians);
        return +beamLength.toFixed(3);
    };


    const handleSaveMasts = () => {
        let lanterns = [...(currColumn?.values?.lanterns || [])];
        const mountingType = currColumn?.values?.mountingType;

        if (mountingType === 'column') {
            // === Column mounting type logic ===
            lanterns.sort((a, b) => (a.positionAngle ?? 0) - (b.positionAngle ?? 0));

            const height = currColumn?.values?.height || 6;
            const defaultOutreach = currColumn?.values?.outreach || 0;
            const numericDisplayX = Number(displayX);
            const numericDisplayY = Number(displayY);

            lanterns = lanterns.map((lantern) => {
                const positionAngle = ((parseFloat(lantern.positionAngle) % 360 + 360) % 360).toFixed(2);
                const offset = parseFloat(lantern.offset ?? 0);
                const tilt = parseFloat(lantern.beamAimingInfo?.tilt ?? 0);
                const outreach = parseFloat(lantern.outreach ?? defaultOutreach);

                // Trust positionAngle + tilt; recompute beamEndPoint
                let beamLength = getBeamLengthFromTilt(tilt, height);
                beamLength = Math.max(beamLength, 0.75);

                const angleRad = (Number(positionAngle) - 90) * Math.PI / 180;

                return {
                    ...lantern,
                    positionAngle: parseFloat(positionAngle),
                    offset,
                    outreach,
                    beamAimingInfo: {
                        beamLength,
                        beamEndPoint: {
                            x: numericDisplayX + beamLength * Math.cos(angleRad),
                            y: numericDisplayY + beamLength * Math.sin(angleRad),
                        },
                        tilt
                    }
                };
            });
        } else {
            // === Wall mounting type logic ===
            lanterns.sort((a, b) => (b.offset ?? 0) - (a.offset ?? 0));
            const barThickness = 0.4;

            const columnAngleDeg = Number(currColumn?.values?.positionAngle ?? 0);
            const columnAngleRad = (columnAngleDeg * Math.PI) / 180;

            const barCenter = { x: Number(displayX), y: Number(displayY) };

            const offsets = lanterns.map(l => parseFloat(l.offset) || 0);
            const minOffset = Math.min(...offsets);
            const maxOffset = Math.max(...offsets);
            const centerOffset = (minOffset + maxOffset) / 2;

            const rotateAround = (point, center, angleRad) => {
                const translated = {
                    x: point.x - center.x,
                    y: point.y - center.y,
                };
                const rotated = {
                    x: translated.x * Math.cos(angleRad) - translated.y * Math.sin(angleRad),
                    y: translated.x * Math.sin(angleRad) + translated.y * Math.cos(angleRad),
                };
                return {
                    x: center.x + rotated.x,
                    y: center.y + rotated.y,
                };
            };

            lanterns = lanterns.map((lantern) => {
                const offset = parseFloat(lantern.offset ?? 0);
                const outreach = parseFloat(lantern.outreach ?? currColumn.values.outreach ?? 0);
                const columnHeight = currColumn.values.height || 6;

                const offsetFromCenter = offset - centerOffset;
                const armX = offsetFromCenter;
                const armY = -barThickness / 2;

                const preRotatedBase = {
                    x: barCenter.x + armX,
                    y: barCenter.y + armY,
                };

                const beamOrigin = rotateAround(preRotatedBase, barCenter, columnAngleRad);

                let beamEndPoint = lantern.beamAimingInfo?.beamEndPoint;
                let beamLength;
                let tilt;
                let positionAngle;

                const isBeamValid = (
                    beamEndPoint &&
                    typeof beamEndPoint.x === "number" && !isNaN(beamEndPoint.x) &&
                    typeof beamEndPoint.y === "number" && !isNaN(beamEndPoint.y)
                );

                if (isBeamValid) {
                    const dx = beamEndPoint.x - beamOrigin.x;
                    const dy = beamEndPoint.y - beamOrigin.y;

                    beamLength = Math.sqrt(dx * dx + dy * dy);
                    tilt = getTiltFromBeamLength(beamLength, columnHeight);

                    const angleFromVertical = Math.atan2(dy, dx) * 180 / Math.PI;
                    positionAngle = (angleFromVertical + 90 + 360) % 360;
                } else {
                    tilt = parseFloat(lantern.beamAimingInfo?.tilt ?? 0);
                    beamLength = getBeamLengthFromTilt(tilt, columnHeight);
                    beamLength = Math.max(beamLength, 0.75);

                    positionAngle = parseFloat(lantern.positionAngle ?? 0);
                    positionAngle = Number((((positionAngle % 360) + 360) % 360).toFixed(2));

                    const beamAngleRad = (positionAngle - 90) * Math.PI / 180;

                    beamEndPoint = {
                        x: beamOrigin.x + beamLength * Math.cos(beamAngleRad),
                        y: beamOrigin.y + beamLength * Math.sin(beamAngleRad),
                    };
                }

                return {
                    ...lantern,
                    positionAngle: Number(positionAngle.toFixed(2)),
                    offset,
                    outreach,
                    beamAimingInfo: {
                        ...lantern.beamAimingInfo,
                        beamLength,
                        beamOrigin,
                        beamEndPoint,
                        tilt,
                    },
                };
            });
        }

        // Finalize common updates
        const xScaler = props.realWorldWidth / props.imagePixelWidth;
        const yScaler = props.realWorldHeight / props.imagePixelHeight;

        const updatedItem = {
            ...currColumn,
            values: {
                ...currColumn.values,
                lanterns,
                point: {
                    x: displayX / xScaler,
                    y: displayY / yScaler
                }
            }
        };

        const updatedMasts = props.columnList.map(mast =>
            mast.id === currColumn.id ? updatedItem : mast
        );

        props.setColumns(updatedMasts);
        setMastSettingsOpen(false);
    };


    useEffect(() => {
        if (!mastSettingsOpen) {
            props.doAreaCalc();
        }
    }, [mastSettingsOpen]);


    const handleGroupDialogOpen = () => {
        setGroupDialogOpen(true);
    };

    const handleGroupDialogClose = () => {
        setGroupDialogOpen(false);
        setSelectedColumns([]);
        setNewGroupName("");
    };

    const handleColumnSelection = (columnId) => {
        setSelectedColumns((prevSelected) =>
            prevSelected.includes(columnId)
                ? prevSelected.filter((id) => id !== columnId)
                : [...prevSelected, columnId]
        );
    };

    const handleGroupSave = () => {
        const updatedColumns = props.columns.map((column) =>
            selectedColumns.includes(column.id)
                ? { ...column, group: newGroupName || column.group }
                : column
        );
        props.setColumns(updatedColumns);
        handleGroupDialogClose();
    };

    const handleGroupSettings = (groupName) => {
        const groupColumns = props.columns.filter(column => (column.group || "Default Group") === groupName);
        if (groupColumns.length > 0) {
            setCurrColumn(groupColumns[0]); // Use the first column as a template
            setGroupName(groupName);
            setGroupSettingsOpen(true);
        }
    };

    const handleGroupSettingsSave = () => {
        const updatedColumns = props.columns.map(column =>
            (column.group || "Default Group") === groupName
                ? { ...column, values: { ...column.values, ...currColumn.values } }
                : column
        );
        props.setColumns(updatedColumns);
        setGroupSettingsOpen(false);
    };

    const handleGroupSelect = (groupName) => {
        // Find all columns in the group
        const groupColumns = props.columns.filter(
            column => (column.group || "Default Group") === groupName
        );
        // Check if all are selected
        const allSelected = groupColumns.every(column => column.selected);
        // Toggle selection: deselect all if all selected, else select all
        const updatedColumns = props.columns.map(column =>
            (column.group || "Default Group") === groupName
            ? { ...column, selected: !allSelected }
            : column
        );
        props.setColumns(updatedColumns);
    };

    const handleGroupDelete = (groupName) => {
        if (groupName === "Default Group") {
            alert("Default Group cannot be deleted.");
            return;
        }
        const updatedColumns = props.columns.map(column =>
            column.group === groupName
                ? { ...column, group: "Default Group" }
                : column
        );
        props.setColumns(updatedColumns);
    };

    useEffect(() => {
        if (state.Plan?.selectedLuminaireNames) {
            setLuminNameList(state.Plan?.selectedLuminaireNames);
        }
        if (state.Plan?.selectedLuminaires) {
            setLuminIdList(state.Plan?.selectedLuminaires);
        }
        if (state.Plan?.selectedLuminaireColors) {
            setLuminColorList(state.Plan?.selectedLuminaireColors);
        }
    }, [state.Plan]);

    useEffect(() => {
        const updatedColors = {};
        props.columns.forEach(column => {
            const luminaireId = column.values?.luminaireId;
            const luminaireIndex = luminIdList.indexOf(luminaireId);
            if (luminaireIndex >= 0) {
                updatedColors[column.id] = luminColorList[luminaireIndex];
            } else {
                updatedColors[column.id] = '#212529';
            }
        });
        setColumnColors(updatedColors);
    }, [luminIdList, luminColorList, props.columns]);

    return (
        <>
            <Dialog
                open={columnInfoOpen}
                disableEscapeKeyDown
                disableEnforceFocus
                hideBackdrop
                BackdropProps={{ open: false }}
            >
                <DialogTitle>Column Setting</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} sx={{ p: 1 }}>
                        {/* Column Name & Height */}
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Column Name"
                                value={currColumn?.name || ''}
                                onChange={handleChangeCurrColumn}
                                variant="outlined"
                                name="name"
                            />
                        </Grid>

                        {/* Position and Angle */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                label="x"
                                value={displayX || ''}
                                onChange={handleChangeCurrColumn}
                                variant="outlined"
                                type="number"
                                name="x"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                label="y"
                                value={displayY || ''}
                                onChange={handleChangeCurrColumn}
                                variant="outlined"
                                type="number"
                                name="y"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                label="Angle"
                                value={currColumn?.values?.positionAngle ?? 0}
                                onChange={handleChangeCurrColumn}
                                variant="outlined"
                                type="number"
                                name="angle"
                            />
                        </Grid>

                        {/* Divider */}
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>

                        {/* Additional Properties */}
                        {['height', 'outreach', 'tilt', 'cant'].map((field) => (
                            <Grid item xs={12} sm={6} key={field}>
                                <TextField
                                    fullWidth
                                    label={field.charAt(0).toUpperCase() + field.slice(1)}
                                    value={currColumn?.values?.[field] ?? ''}
                                    onChange={handleChangeCurrColumn}
                                    variant="outlined"
                                    type="number"
                                    name={field}
                                />
                            </Grid>
                        ))}

                        {/* Luminaire Select */}
                        <Grid item xs={12}>
                            <InputLabel id="luminaireId">Luminaire</InputLabel>
                            {luminNameList?.length > 0 && luminIdList.length > 0 ? (
                                <Select
                                    fullWidth
                                    value={currColumn?.values?.luminaireId || luminIdList[0]}
                                    onChange={handleChangeCurrColumn}
                                    variant="outlined"
                                    name="luminaireId"
                                    label="luminaireId"
                                    sx={{
                                        color: luminColorList[
                                            luminIdList.indexOf(currColumn?.values?.luminaireId || luminIdList[0])
                                        ],
                                    }}
                                >
                                    {luminNameList.map((option, id) => (
                                        <MenuItem
                                            key={option}
                                            value={luminIdList[id]}
                                            style={{ color: luminColorList[id] }}
                                        >
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Select>
                            ) : (
                                <Typography>Please Add Luminaire(s)</Typography>
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={handleSave} variant="contained" color="primary">
                        Save
                    </Button>
                    <Button onClick={() => setColumnInfoOpen(false)} variant="contained">
                        Cancel
                    </Button>
                </DialogActions>

            </Dialog>

            {/* Mast Settings */}
            <Dialog
                open={mastSettingsOpen}
                onClose={() => setMastSettingsOpen(false)}
                disableEscapeKeyDown
                disableEnforceFocus
                hideBackdrop
                BackdropProps={{ open: false }}
                fullWidth
                maxWidth="sm"  // Constrain width
            >
                <DialogTitle>Mast Setting</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        {/* Name and Mounting - stacked */}
                        <Grid item xs={12}>
                            <TextField
                                label="Mast Name"
                                name="name"
                                value={currColumn?.name || ''}
                                onChange={handleChangeCurrColumn}
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                select
                                label="Mounting"
                                name="mounting"
                                value={currColumn?.values?.mountingType || 'column'}
                                onChange={(e) =>
                                    handleChangeCurrColumn({
                                        target: { name: 'mounting', value: e.target.value },
                                    })
                                }
                                fullWidth
                                variant="outlined"
                            >
                                <MenuItem value="column">Column</MenuItem>
                                <MenuItem value="wall">Wall</MenuItem>
                            </TextField>
                        </Grid>

                        {/* Lantern Count and Buttons */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                label="Number of Lanterns"
                                name="lanternCount"
                                variant="outlined"
                                value={currColumn?.values?.lanternCount || 1}
                                onChange={(e) =>
                                    handleChangeCurrColumn({
                                        target: { name: 'lanternCount', value: e.target.value },
                                    })
                                }
                            >
                                {Array.from({ length: 16 }, (_, i) => i + 1).map((count) => (
                                    <MenuItem key={count} value={count}>
                                        {count}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                            <Button
                                onClick={() => toggleSetLanternsDialog(true)}
                                variant="outlined"
                                sx={{ height: '56px', minWidth: '100px' }}
                            >
                                Set Lanterns
                            </Button>
                            <Button
                                onClick={() => handleAddLantern(null)}
                                variant="contained"
                                disabled={currColumn?.values?.lanterns?.length >= 16}
                                sx={{ height: '56px', minWidth: '80px' }}
                            >
                                Add
                            </Button>
                        </Grid>

                        <Grid item xs={12}>
                            <InputLabel sx={{ mb: 1 }}>Lanterns</InputLabel>
                            <Box
                                sx={{
                                    height: 160,
                                    overflowY: 'auto',
                                    pr: 1,
                                    pt: 1,
                                }}
                            >
                                {currColumn?.values?.lanterns?.map((lantern, index) => {
                                    const showOutreach = currColumn?.values?.useLanternOutreach;
                                    const showTilt = currColumn?.values?.configuration !== "None";
                                    const mountingType = currColumn?.values?.mountingType || 'column';

                                    const visibleFields = (mountingType == "column" ? 2 : 3) + (showOutreach ? 1 : 0) + (showTilt ? 1 : 0);
                                    const gridSize = Math.floor(12 / (visibleFields + 1));

                                    return (
                                        <Grid
                                            container
                                            spacing={1}
                                            key={index}
                                            alignItems="center"
                                            sx={{ mb: 1 }}
                                        >
                                            {currColumn?.values?.mountingType === 'column' ? (
                                                <Grid item xs={gridSize}>
                                                    <TextField
                                                        label={`Lantern ${index + 1} Angle`}
                                                        value={lantern.positionAngle}
                                                        onChange={(e) => handleLanternAngleChange(index, e.target.value)}
                                                        type="number"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </Grid>
                                            ) : (
                                                <>
                                                    <Grid item xs={gridSize}>
                                                        <TextField
                                                            label={`Lantern ${index + 1} Angle`}
                                                            value={lantern.positionAngle}
                                                            onChange={(e) => handleLanternAngleChange(index, e.target.value)}
                                                            type="number"
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={gridSize}>
                                                        <TextField
                                                            label={`Lantern ${index + 1} Offset`}
                                                            value={lantern.offset}
                                                            onChange={(e) => handleLanternOffsetChange(index, e.target.value)}
                                                            type="number"
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                </>
                                            )}


                                            {/* Luminaire Select */}
                                            <Grid item xs={gridSize}>
                                                <FormControl fullWidth variant="outlined">
                                                    <InputLabel id={`luminaire-label-${index}`}>Luminaire</InputLabel>
                                                    <Select
                                                        labelId={`luminaire-label-${index}`}
                                                        label="Luminaire"
                                                        value={lantern.luminaireId || luminIdList[0]}
                                                        onChange={(e) => handleLanternLuminaireChange(index, e.target.value)}
                                                        variant="outlined"
                                                        name="luminaireId"
                                                        style={{
                                                            color: luminColorList[
                                                                luminIdList.indexOf(lantern.luminaireId || luminIdList[0])
                                                            ]
                                                        }}
                                                    >
                                                        {luminNameList.map((option, id) => (
                                                            <MenuItem
                                                                key={option}
                                                                value={luminIdList[id]}
                                                                style={{ color: luminColorList[id] }}
                                                            >
                                                                {option}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>


                                            {/* Outreach (if enabled) */}
                                            {showOutreach && (
                                                <Grid item xs={gridSize}>
                                                    <TextField
                                                        label="Outreach"
                                                        value={lantern.outreach ?? ''}
                                                        onChange={(e) => handleLanternOutreachChange(index, e.target.value)}
                                                        type="number"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </Grid>
                                            )}

                                            {/* Tilt (if config !== None) */}
                                            {showTilt && (
                                                <Grid item xs={gridSize}>
                                                    <TextField
                                                        label="Tilt"
                                                        value={lantern.beamAimingInfo.tilt ?? ''}
                                                        onChange={(e) => handleLanternTiltChange(index, e.target.value)}
                                                        type="number"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                </Grid>
                                            )}

                                            {/* Remove Button */}
                                            <Grid item xs={gridSize}>
                                                {index > 0 && (
                                                    <Button
                                                        onClick={() => handleRemoveLantern(index)}
                                                        color="primary"
                                                        variant="outlined"
                                                        fullWidth
                                                    >
                                                        Remove
                                                    </Button>
                                                )}
                                            </Grid>
                                        </Grid>
                                    );
                                })}

                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                select
                                fullWidth
                                label="Configuration"
                                name="configuration"
                                value={currColumn?.values?.configuration || 'None'}
                                onChange={handleChangeCurrColumn}
                                variant="outlined"
                            >
                                <MenuItem value="None">None</MenuItem>
                                <MenuItem value="Beam Aiming">Beam Aiming</MenuItem>
                                <MenuItem value="Asymmetrical Flood Aiming">Asymmetrical Flood Aiming</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12}>
                            <InputLabel sx={{ mb: 1 }}>Mast Configuration</InputLabel>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="x"
                                    value={displayX || ''}
                                    onChange={handleChangeCurrColumn}
                                    variant="outlined"
                                    type="number"
                                    name="x"
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="y"
                                    value={displayY || ''}
                                    onChange={handleChangeCurrColumn}
                                    variant="outlined"
                                    type="number"
                                    name="y"
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Angle"
                                    value={currColumn?.values?.positionAngle !== undefined ? currColumn?.values?.positionAngle : 0}
                                    onChange={handleChangeCurrColumn}
                                    variant="outlined"
                                    type="number"
                                    name="angle"
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Divider style={{ margin: '10px' }} />
                        </Grid>

                        {['height', 'outreach', 'tilt', 'cant'].map((field) => (
                            <Grid item xs={12} sm={6} key={field}>
                                {field === "outreach" ? (
                                    <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                        {!currColumn.values.useLanternOutreach ? (
                                            <TextField
                                                fullWidth
                                                label={field.charAt(0).toUpperCase() + field.slice(1)}
                                                value={currColumn?.values?.[field] ?? ''}
                                                onChange={handleChangeCurrColumn}
                                                variant="outlined"
                                                type="number"
                                                name={field}
                                            />
                                        ) : (
                                            <Box sx={{ height: '56px', width: '100%' }} />
                                        )}

                                        <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                                            <span>Individual</span>
                                            <Switch
                                                onChange={handleLanternOutreach}
                                                checked={currColumn.values.useLanternOutreach || false}
                                                name="useLanternOutreach"
                                                color="primary"
                                            />
                                        </label>
                                    </div>
                                ) : field === "tilt" ? (
                                    currColumn.values.configuration === "None" ? (
                                        <TextField
                                            fullWidth
                                            label={field.charAt(0).toUpperCase() + field.slice(1)}
                                            value={currColumn?.values?.[field] ?? ''}
                                            onChange={handleChangeCurrColumn}
                                            variant="outlined"
                                            type="number"
                                            name={field}
                                        />
                                    ) : (
                                        <Box sx={{ height: '56px', width: '100%' }} />
                                    )
                                ) : (
                                    <TextField
                                        fullWidth
                                        label={field.charAt(0).toUpperCase() + field.slice(1)}
                                        value={currColumn?.values?.[field] ?? ''}
                                        onChange={handleChangeCurrColumn}
                                        variant="outlined"
                                        type="number"
                                        name={field}
                                    />
                                )}
                            </Grid>
                        ))}

                    </Grid>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={handleSaveMasts} variant="contained" color="primary">
                        Save
                    </Button>
                    <Button onClick={() => setMastSettingsOpen(false)} variant="contained">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog >

            <Dialog open={setLanternsDialogOpen} onClose={() => toggleSetLanternsDialog(false)}>
                <DialogTitle>Set Lanterns?</DialogTitle>
                <DialogContent>
                    This will set all lanterns to a default configuration. Do you want to continue? - You will lose any custom lantern settings.
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            handleAddLantern(parseInt(currColumn?.values?.lanternCount || 1));
                            toggleSetLanternsDialog(false);
                        }}
                        color="primary"
                        variant="contained"
                    >
                        Confirm
                    </Button>
                    <Button onClick={() => toggleSetLanternsDialog(false)} color="error" variant="contained">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>


            <Draggable style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '350px' }}>
                <Dialog open={groupDialogOpen}
                    disableEscapeKeyDown
                    disableEnforceFocus
                    hideBackdrop
                    BackdropProps={{ open: false }}
                    onClose={handleGroupDialogClose}>
                    <DialogTitle>Edit Column Groups</DialogTitle>
                    <DialogContent>
                        <Typography>Select columns to assign them to a group. You can also create a new group or select an existing group to assign the selected columns.</Typography>
                        {Object.entries(
                            props.columns.reduce((groups, column) => {
                                const group = column.group || "Default Group";
                                if (!groups[group]) groups[group] = [];
                                groups[group].push(column);
                                return groups;
                            }, {})
                        ).map(([groupName, groupColumns]) => (
                            <Box key={groupName} style={{ marginBottom: '10px' }}>
                                <Typography variant="h6">{groupName}</Typography>
                                <List>
                                    {groupColumns.map((column) => (
                                        <ListItem key={column.id}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={selectedColumns.includes(column.id)}
                                                        onChange={() => handleColumnSelection(column.id)}
                                                    />
                                                }
                                                label={column.name}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                        ))}
                        <Typography style={{ marginTop: '10px' }}>Enter a new group name or select an existing group:</Typography>
                        <TextField
                            label="New Group Name"
                            value={newGroupName}
                            onChange={(e) => setNewGroupName(e.target.value)}
                            style={{ margin: '10px', width: '100%' }}
                            variant="outlined"
                        />
                        <InputLabel id="existingGroup">Existing Groups</InputLabel>
                        <Select
                            value={newGroupName}
                            onChange={(e) => setNewGroupName(e.target.value)}
                            style={{ margin: '10px', width: '100%' }}
                            variant="outlined"
                        >
                            {Object.keys(
                                props.columns.reduce((groups, column) => {
                                    const group = column.group || "Default Group";
                                    groups[group] = true;
                                    return groups;
                                }, {})
                            ).map((group) => (
                                <MenuItem key={group} value={group}>
                                    {group}
                                </MenuItem>
                            ))}
                        </Select>
                    </DialogContent>
                    <div style={{ textAlign: "right", margin: 10 }}>
                        <Button
                            onClick={handleGroupSave}
                            color="primary"
                            variant="contained"
                            style={{ margin: '10px' }}
                        >
                            Save
                        </Button>
                        <Button
                            onClick={handleGroupDialogClose}
                            color="primary"
                            variant="contained"
                            style={{ margin: '10px' }}
                        >
                            Cancel
                        </Button>
                    </div>
                </Dialog>
            </Draggable>
            <Draggable style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '350px' }}>
                <Dialog
                    open={groupSettingsOpen}
                    onClose={() => setGroupSettingsOpen(false)}
                    disableEscapeKeyDown
                    disableEnforceFocus
                    hideBackdrop
                    BackdropProps={{ open: false }}
                >
                    <DialogTitle>Group Setting: {groupName}</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Height"
                            value={currColumn?.values?.height || ''}
                            onChange={(e) => handleChangeCurrColumn(e)}
                            style={{ margin: '10px' }}
                            variant="outlined"
                            type="number"
                            name="height"
                        />
                        <TextField
                            label="Dim"
                            value={currColumn?.values?.dimFactor || ''}
                            onChange={(e) => handleChangeCurrColumn(e)}
                            style={{ margin: '10px' }}
                            variant="outlined"
                            type="number"
                            name="dimFactor"
                        />
                        <TextField
                            label="Outreach"
                            value={currColumn?.values?.outreach || ''}
                            onChange={(e) => handleChangeCurrColumn(e)}
                            style={{ margin: '10px' }}
                            variant="outlined"
                            type="number"
                            name="outreach"
                        />
                        <TextField
                            label="Cant"
                            value={currColumn?.values?.cant || ''}
                            onChange={(e) => handleChangeCurrColumn(e)}
                            style={{ margin: '10px' }}
                            variant="outlined"
                            type="number"
                            name="cant"
                        />
                        <TextField
                            label="Tilt"
                            value={currColumn?.values?.tilt || ''}
                            onChange={(e) => handleChangeCurrColumn(e)}
                            style={{ margin: '10px' }}
                            variant="outlined"
                            type="number"
                            name="tilt"
                        />
                        <InputLabel id="luminaireId">Luminaire</InputLabel>
                        {luminNameList?.length > 0 && luminIdList.length > 0 ? (
                            <Select
                                value={currColumn?.values?.luminaireId || luminIdList[0]}
                                onChange={(e) => handleChangeCurrColumn(e)}
                                style={{
                                    margin: '10px',
                                    width: '80%',
                                    color: luminColorList[luminIdList.indexOf(currColumn?.values?.luminaireId || luminIdList[0])]
                                }}
                                variant="outlined"
                                name="luminaireId"
                                label="luminaireId"
                            >
                                {luminNameList.map((option, id) => (
                                    <MenuItem
                                        key={option}
                                        value={luminIdList[id]}
                                        style={{ color: luminColorList[id] }}
                                    >
                                        {option}
                                    </MenuItem>
                                ))}
                            </Select>
                        ) : (
                            <Typography>Please Add Luminaire(s)</Typography>
                        )}
                    </DialogContent>
                    <div style={{ textAlign: "right", margin: 10 }}>
                        <Button
                            onClick={handleGroupSettingsSave}
                            color="primary"
                            style={{ margin: '10px' }}
                            variant="contained"
                        >
                            <Typography>Save</Typography>
                        </Button>
                        <Button
                            onClick={() => setGroupSettingsOpen(false)}
                            color="primary"
                            style={{ margin: '10px' }}
                            variant="contained"
                        >
                            <Typography>Cancel</Typography>
                        </Button>
                    </div>
                </Dialog>
            </Draggable>
            <Box sx={{ maxHeight: "500px", overflowY: "auto", width: "100%" }}>
                <Button
                    onClick={handleGroupDialogOpen}
                    color="primary"
                    variant="contained"
                    style={{ margin: '10px' }}
                >
                    Edit Groups
                </Button>
                {Object.entries(
                    props.columns.reduce((groups, column) => {
                        const group = column.group || "Default Group";
                        if (!groups[group]) groups[group] = [];
                        groups[group].push(column);
                        return groups;
                    }, {})
                ).map(([groupName, groupColumns]) => (
                    <Accordion key={groupName} defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography style={{
                                fontWeight: 'bold',
                                fontSize: '0.9rem',
                                marginTop: 'auto',
                                marginBottom: 'auto',
                                marginLeft: '10px',
                                marginRight: 'auto',
                            }}>{groupName}</Typography>
                            <IconButton
                                edge="end"
                                aria-label="group-settings"
                                onClick={() => handleGroupSettings(groupName)}
                                style={{ marginLeft: 'auto' }}
                            >
                                <SettingsIcon />
                            </IconButton>
                            <IconButton
                                edge="end"
                                aria-label="group-select"
                                onClick={() => handleGroupSelect(groupName)}
                                style={{ marginLeft: 'auto' }}
                            >
                                <SelectAllIcon />
                            </IconButton>
                            {groupName !== "Default Group" && (
                                <IconButton
                                    edge="end"
                                    aria-label="group-delete"
                                    onClick={() => handleGroupDelete(groupName)}
                                    style={{ marginLeft: '10px' }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            )}
                        </AccordionSummary>
                        <AccordionDetails>
                            <List>
                                {groupColumns.map((column, index) => (
                                    <ListItem
                                        key={index}
                                        onClick={() => props.selectColumn(column.id)}
                                        style={column.selected ? { border: "2px solid darkturquoise " } : {}}
                                    >
                                        <ListItem disableGutters>
                                            <Tooltip title={column.name} placement="top">
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                    {column.isMast ? (
                                                        <WorkspacesIcon sx={{ color: column.isMast ? "" : columnColors[column.id], fontSize: 20 }} />
                                                    ) : (
                                                        <CircleIcon sx={{ color: columnColors[column.id], fontSize: 20 }} />
                                                    )}
                                                    <ListItemText
                                                        primary={column.name && column.name.length > 10 ? `${column.name.slice(0, 9)}...` : column.name}
                                                        primaryTypographyProps={{ style: { userSelect: 'none', color: column.isMast ? "" : columnColors[column.id], fontSize: 14 } }}
                                                    />
                                                </div>
                                            </Tooltip>
                                        </ListItem>
                                        <ListItemSecondaryAction>
                                            <IconButton edge="end" aria-label="setting" onClick={() => handleInfoOpen(index)}>
                                                <SettingsIcon />
                                            </IconButton>
                                            <Tooltip title={column.isMast ? "Swap to Column" : "Swap to Mast"} placement="top">
                                                <IconButton edge="end" aria-label="setting" onClick={() => swapType(column.id)}>
                                                    <SwapHoriz />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Focus on column" placement="top">
                                                <IconButton edge="end" aria-label="setting" onClick={() => props.focusColumn(column.id)}>
                                                    <CenterFocusWeakIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <IconButton edge="end" aria-label="delete" onClick={() => props.deleteColumn(column.id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                ))}
                            </List>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Box>
        </>
    );
}
